// Blocco dello scroll della pagina quando c'è un modal aperto, con CONTATORE.
//
// Prima ogni modal salvava "il valore precedente" di body.style.overflow e lo ripristinava alla chiusura.
// Se due modal si chiudevano insieme (o nell'ordine sbagliato), restava salvato "hidden" e la pagina
// rimaneva senza scroll: le ultime righe delle tabelle sembravano nascoste.
// Con il contatore il valore originale si ripristina solo quando si chiude l'ULTIMO blocco.

let contatore = 0;
let valoreOriginale = '';

/** Blocca lo scroll della pagina. Ritorna la funzione che toglie QUESTO blocco (da chiamare una sola volta). */
export const bloccaScroll = () => {
  if (typeof document === 'undefined') return () => {};
  if (contatore === 0) valoreOriginale = document.body.style.overflow;
  contatore += 1;
  document.body.style.overflow = 'hidden';

  let rilasciato = false;
  return () => {
    if (rilasciato) return;
    rilasciato = true;
    contatore = Math.max(0, contatore - 1);
    if (contatore === 0) document.body.style.overflow = valoreOriginale;
  };
};

/** Sblocca tutto (usato all'ingresso di una pagina, quando non può esserci nessun modal aperto). */
export const sbloccaTuttoLoScroll = () => {
  if (typeof document === 'undefined') return;
  contatore = 0;
  valoreOriginale = '';
  document.body.style.overflow = '';
};
